
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
function App() {
  return (
    <><><Header /></><><Hero /><About /><Services /><Contact /><Footer /></></>
  );
}

export default App;
